<div *ngIf="(loading$ | async)" class="dialog-loading">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-title-content">
    <div class="dialog-title"></div>
    <div (click)="minimize()" *ngIf="data?.contract?.id" class="dialog-close">
        <mat-icon>minimize</mat-icon>
    </div>
    <div (click)="closeDialog(false)" class="dialog-close">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content tab-container">
    <div class="tab-actions-container" style="margin-right: 80px">
        <button (click)="$event.stopPropagation(); addContactFormToggle()"
                *ngIf="contractTabs.selectedIndex === 1 && (checkPermissions('BILLING_NEW_EDIT') || checkPermissions('BILLING_SINGLE_CONTRACT_EDIT'))"
                class="action-button green">
            <mat-icon class="action-button-icon">playlist_add</mat-icon>
            <span>{{ 'Додати контакт' }}</span>
        </button>
        <ng-container *ngIf="contractTabs.selectedIndex === 2 && (checkPermissions('BILLING_NEW_EDIT') || checkPermissions('BILLING_SINGLE_CONTRACT_EDIT'))">
            <button *ngIf="contractData[0].date"
                    [matMenuTriggerFor]="contractFileMenu"
                    class="action-button green"

            >
                <mat-icon class="action-button-icon">playlist_add</mat-icon>
                <span>{{ 'Додати файл' }}</span>
            </button>

            <mat-menu #contractFileMenu class="wide-menu" xPosition="before">
                <button (click)="generateContractFile('CONTRACT_WITH_ANNEX')" class="item-action-button gray" mat-menu-item>
                    <mat-icon>auto_mode</mat-icon>
                    <span>{{ 'Згенерувати файл договору з додатком від' }} {{ contractData[0].date | date: 'dd.MM.yyyy' }}</span>
                </button>
                <button (click)="generateContractFile('ANNEX')" *ngIf="data.contract?.type == 'SAAS' || data.contract?.type == 'ACCOUNTING'" class="item-action-button gray" mat-menu-item>
                    <mat-icon>auto_mode</mat-icon>
                    <span>{{ 'Згенерувати файл додатку від' }} {{ contractData[0].date | date: 'dd.MM.yyyy' }}</span>
                </button>
                <mat-divider class="divider"></mat-divider>
                <button (click)="contractFileInput.click()" class="item-action-button gray" mat-menu-item>
                    <mat-icon>file_upload</mat-icon>
                    <input #contractFileInput (change)="uploadContractFile($event, 'CONTRACT_WITH_ANNEX')" [hidden]="true" accept=".doc, .docx, .pdf, .p7s" type="file">
                    <span>{{ 'Завантажити файл договору з додатком від' }} {{ contractData[0].date | date: 'dd.MM.yyyy' }}</span>
                </button>
                <ng-container *ngIf="data.contract?.type == 'SAAS'">
                    <button (click)="annexFileInput.click()" class="item-action-button gray" mat-menu-item>
                        <mat-icon>file_upload</mat-icon>
                        <span>{{ 'Завантажити файл додатку від' }} {{ contractData[0].date | date: 'dd.MM.yyyy' }}</span>
                    </button>
                </ng-container>
                <input #annexFileInput (change)="uploadContractFile($event, 'ANNEX')" [hidden]="true" accept=".doc, .docx, .pdf, .p7s" type="file">
                <ng-container *ngIf="contractData?.length && contractData.length > 1">
                    <mat-divider class="divider"></mat-divider>
                    <button [matMenuTriggerFor]="contractFileSubMenu" class="item-action-button gray" mat-menu-item>
                        <mat-icon>skip_previous</mat-icon>
                        <span>Інші версії документу</span>
                        <mat-menu #contractFileSubMenu class="wide-menu" xPosition="before">
                            <ng-container *ngFor="let annex of contractData | slice: 1; let i = index">
                                <div class="menu-subtitle">Версія з додатком від {{ annex.date | date: 'dd.MM.yyyy' }}</div>
                                <button (click)="generateContractFile('CONTRACT_WITH_ANNEX', annex.date)" class="item-action-button gray" mat-menu-item>
                                    <mat-icon>auto_mode</mat-icon>
                                    <span>{{ 'Згенерувати файл договору' }}</span>
                                </button>
                                <button (click)="generateContractFile('ANNEX', annex.date)" *ngIf="data.contract?.type == 'SAAS'" class="item-action-button gray"
                                        mat-menu-item>
                                    <mat-icon>auto_mode</mat-icon>
                                    <span>{{ 'Згенерувати файл додатку' }}</span>
                                </button>
                                <mat-divider class="divider"></mat-divider>
                                <button (click)="selectedAnnexDateForFile = annex.date; contractFileInput.click()" class="item-action-button gray" mat-menu-item>
                                    <mat-icon>file_upload</mat-icon>
                                    <span>{{ 'Завантажити файл договору' }}</span>
                                </button>
                                <ng-container>
                                    <button (click)="selectedAnnexDateForFile = annex.date; annexFileInput.click()" class="item-action-button gray" mat-menu-item>
                                        <mat-icon>file_upload</mat-icon>
                                        <span>{{ 'Завантажити файл додатку' }}</span>
                                    </button>
                                </ng-container>
                            </ng-container>
                        </mat-menu>
                    </button>
                </ng-container>
            </mat-menu>
        </ng-container>

        <button *ngIf="(contractTabs.selectedIndex === 3 && checkPermissions('BILLING_NEW_ACT_EDIT'))"
                [matMenuTriggerFor]="addDocumentMenu"
                (click)="$event.stopPropagation(); "
                class="action-button green">
            <mat-icon class="action-button-icon">playlist_add</mat-icon>
            <span>{{ 'Додати' }}</span>
        </button>
        <mat-menu #addDocumentMenu class="wide-menu" xPosition="before">
            <button (click)="addDocument('INVOICE')" class="item-action-button gray" mat-menu-item>
                <span>Рахунок</span>
            </button>
            <button (click)="addDocument('ACT')" class="item-action-button gray" mat-menu-item>
                <span>Акт</span>
            </button>
            <button (click)="pickPayment()" class="item-action-button gray" mat-menu-item
                    *ngIf="checkPermissions('BILLING_NEW_TRANSACTION_EDIT')">
                <span>Підібрати платіж</span>
            </button>
            <button (click)="refund()" class="item-action-button gray" mat-menu-item
                    *ngIf="checkPermissions('BILLING_NEW_TRANSACTION_EDIT')">
                <span>Повернути кошти</span>
            </button>
        </mat-menu>
    </div>
    <mat-tab-group #contractTabs (selectedTabChange)="tabChanged($event)" animationDuration="0ms" class="dialog-tabs no-min-with">
        <mat-tab label="{{'modules.billing.agreements.agreementDialog.title' | translate}}">
            <div class="no-overflow df-c gap20">
                <div class="dialog-form scroll-content-padding df gap20">
                    <form [formGroup]="contractForm" autocomplete="off" class="full-width df gap15">
                        <div class="contract-dialog-data-content df-c gap15">
                            <div class="df jc-sb ai-c gap15">
                                <b class="dialog-subtitle-label">Основна інформація</b>
                                <div class="df jc-e ai-c">
                                    <div class="df jc-e ai-c" style="height: 20px">
                                        <button *ngIf="data?.contract?.id" [matMenuTriggerFor]="agreementMenu" class="button-form-field green df ai-c jc-c">
                                            <mat-icon class="button-form-field-icon">description</mat-icon>
                                        </button>
                                    </div>

                                    <mat-menu #agreementMenu class="wide-menu" xPosition="before">
                                        <button (click)="downloadContractTemplate()" class="item-action-button gray" mat-menu-item>
                                            <mat-icon>system_update_alt</mat-icon>
                                            <span>{{ 'modules.billing.agreements.agreementDialog.labels.downloadTemplate' | translate }}</span>
                                        </button>
                                        <button (click)="fileInput.click()" class="item-action-button gray" mat-menu-item>
                                            <mat-icon>file_upload</mat-icon>
                                            <input #fileInput (change)="uploadContractTemplate($event)" [hidden]="true" accept=".docx" id="file_input" type="file">
                                            <span>{{ 'modules.billing.agreements.agreementDialog.labels.uploadAgreement' | translate }}</span>
                                        </button>
                                        <button (click)="clearContractTemplate()" class="item-action-button gray" mat-menu-item>
                                            <mat-icon>undo</mat-icon>
                                            <span>{{ 'modules.billing.agreements.agreementDialog.labels.clearTemplate' | translate }}</span>
                                        </button>
                                    </mat-menu>
                                </div>
                            </div>
                            <div class="df-c gap20">
                                <div class="df jc-s ai-c gap25">
                                    <mat-form-field appearance="outline" class="no-padding grow" floatLabel="always">
                                        <mat-label>{{ 'Наша компанія' | translate }}</mat-label>
                                        <mat-select (selectionChange)="companySelected($event)" [disableOptionCentering]="true" class="select-panel"
                                                    formControlName="dahCounterParty"
                                                    panelClass="dialog-select-panel"
                                        >
                                            <mat-option *ngFor="let company of companies" [value]="company">{{ company.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <div *ngIf="contractEditable && selectedCompany && availableAmount" class="available-amount df-c" style="gap: 3px;">
                                        <span>{{ availableAmount > 0 ? 'Доступно:' : 'Перевищено:' }}</span>
                                        <span [ngClass]="availableAmount > 0 ? 'positive' : 'negative'">{{ availableAmount | currency: '':'грн':'0.0-0' }}</span>
                                    </div>
                                </div>

                                <div class="df gap20">
                                    <mat-form-field appearance="outline" class="no-padding" floatLabel="always" style="width: 200px; min-width: 200px; max-width: 200px">
                                        <mat-label>{{ 'modules.billing.agreements.agreementDialog.labels.number' | translate }}</mat-label>
                                        <input formControlName="number" matInput type="text">
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="no-padding" floatLabel="always" style="width: 300px; min-width: 300px; max-width: 300px">
                                        <mat-label>{{ 'modules.billing.agreements.agreementDialog.labels.contractDate' | translate }}</mat-label>
                                        <input [matDatepicker]="contractDate" formControlName="contractDate" matInput>
                                        <mat-datepicker-toggle [for]="contractDate" matSuffix>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #contractDate></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div class="df gap20">
                                    <mat-form-field appearance="outline" class="no-padding" floatLabel="always" style="width: 200px; min-width: 200px; max-width: 200px">
                                        <mat-label>{{ 'modules.billing.agreements.agreementDialog.labels.type' | translate }}</mat-label>
                                        <mat-select (selectionChange)="setPayerTypeDisable()" [disableOptionCentering]="true" [disabled]="true" class="select-panel"
                                                    formControlName="type" panelClass="dialog-select-panel">
                                            <mat-option [value]="'SAAS'">{{ 'modules.billing.agreements.types.SAAS' | translate }}</mat-option>
                                            <mat-option [value]="'ACCOUNTING'">{{ 'modules.billing.agreements.types.ACCOUNTING' | translate }}</mat-option>
                                            <mat-option [value]="'PERSONAL_ACCOUNTING'">{{ 'modules.billing.agreements.types.PERSONAL_ACCOUNTING' | translate }}</mat-option>
                                            <mat-option [value]="'BUSINESS_SAAS'">{{ 'modules.billing.agreements.types.BUSINESS_SAAS' | translate }}</mat-option>
                                            <mat-option [value]="'BUSINESS_ACCOUNTING'">{{ 'modules.billing.agreements.types.BUSINESS_ACCOUNTING' | translate }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <div style="width: 300px; min-width: 300px; max-width: 300px;" class="df gap20">
                                        <mat-form-field appearance="outline" class="no-padding grow" floatLabel="always">
                                            <mat-label>{{ 'modules.billing.agreements.agreementDialog.labels.status' | translate }}</mat-label>
                                            <mat-select (selectionChange)="statusChanged($event)" [disableOptionCentering]="true" class="select-panel"
                                                        formControlName="status"
                                                        panelClass="dialog-select-panel"
                                            >
                                                <mat-option [value]="'CREATED'">{{ 'modules.billing.agreements.statuses.CREATED' | translate }}</mat-option>
                                                <mat-option [value]="'CANCELLED'">{{ 'modules.billing.agreements.statuses.CANCELLED' | translate }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <range-date-picker valueType="month" *ngIf="contractForm.get('status')?.value == 'CANCELLED'"
                                                               [appearance]="'outline'"
                                                               [label]="'Дата'"
                                                               [minDate]="contractForm.get('contractDate')?.value"
                                                               formControlName="cancelDate" style="width: 160px; min-width: 160px; max-width: 160px">
                                        </range-date-picker>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="contract-dialog-data-content grow df-c gap15">
                            <div class="df jc-sb ai-c gap15">
                                <b class="dialog-subtitle-label">Інформація про оплату</b>
                            </div>
                            <div class="df-c gap20">
                                <div class="df gap20">
                                    <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 170px; min-width: 170px; max-width: 170px">
                                        <mat-label>{{ 'modules.billing.agreements.list.table.ownerType' | translate }}</mat-label>
                                        <mat-select (selectionChange)="payerTypeChanged($event)"
                                                    [disabled]="true"
                                                    [disableOptionCentering]="true" class="select-panel" formControlName="payerType"
                                                    panelClass="dialog-select-panel">
                                            <mat-option [value]="'ASSOCIATION'">{{ 'modules.billing.agreements.ownerTypes.ASSOCIATION' | translate }}</mat-option>
                                            <mat-option [value]="'COUNTERPARTY'">{{ 'modules.billing.agreements.ownerTypes.COUNTERPARTY' | translate }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always" style="width: 100px; min-width: 100px; max-width: 100px">
                                        <mat-label>{{ 'modules.billing.agreements.agreementDialog.labels.invoiceMonths' | translate }}</mat-label>
                                        <mat-select [disableOptionCentering]="true" class="select-panel" formControlName="actPerMonths" panelClass="dialog-select-panel">
                                            <mat-option *ngFor="let item of [].constructor(12); let i = index" [value]="i + 1">{{ i + 1 }} міс.</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                </div>

                                <div class="full-width">
                                    <autocomplete-item-field (selected)="confirmGetCalculation($event?.id, 0)"
                                                             [canOpenItem]="true"
                                                             [canOpenList]="true"
                                                             [dataType]="'ASSOCIATION'"
                                                             [disabled]="!contractEditable || !!data.association"
                                                             [hidden]="contractForm.get('payerType')?.value == 'COUNTERPARTY'"
                                                             [lazyLoadModule]="true"
                                                             [props]="{disableAddContract: true}"
                                                             formControlName="organization"
                                                             label="{{'modules.billing.agreements.ownerTypes.ASSOCIATION' | translate}}"
                                    ></autocomplete-item-field>

                                    <autocomplete-item-field [canAddItem]="true"
                                                             [canDeleteItem]="true"
                                                             [canEditItem]="true"
                                                             [canOpenItem]="true"
                                                             [canOpenList]="true"
                                                             [dataType]="'COUNTERPARTY'"
                                                             [disabled]="!contractEditable || !!data.counterparty"
                                                             [hidden]="contractForm.get('payerType')?.value == 'ASSOCIATION'"
                                                             [props]="{disableAddContract: true}"
                                                             formControlName="counterParty"
                                                             label="{{'modules.billing.agreements.ownerTypes.COUNTERPARTY' | translate}}"
                                    ></autocomplete-item-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="scroll-content-padding df jc-sb ai-c gap15">
                    <b class="dialog-subtitle-label">Додатки до договору (вартість)</b>
                    <mat-divider class="grow"></mat-divider>
                </div>

                <div class="no-overflow full-height df">
                    <div *ngIf="data.contract?.id" class="data-list df-c gap20" style="width: 240px; min-width: 240px; max-width: 240px">
                        <div class="df jc-sb ai-c gap15">
                            <b class="dialog-subtitle-label">Перелік</b>
                            <mat-divider class="grow"></mat-divider>
                            @if (['SAAS', 'ACCOUNTING', 'BUSINESS_SAAS', 'BUSINESS_ACCOUNTING'].includes(contractForm.get('type')?.value ?? '')
                                && !(contractForm.get('type')?.value == 'ACCOUNTING' && data.contract?.oldTemplate)) {
                                <span (click)="addContractData()" class="add-row">{{ 'common.addItem' | translate }}</span>
                            }
                        </div>
                        <div class="no-overflow df-c">
                            <div class="scrollable df-c gap5" style="padding-right: 5px">
                                <div (click)="selectContractData(i)" (contextmenu)="$event.preventDefault(); addContractData(i)"
                                     *ngFor="let item of contractData; let i = index"
                                     [ngClass]="{'selected': selectedContractData.index == i}"
                                     class="data-item clickable df jc-sb ai-c">
                                    <div>
                                        {{ item.date ? 'Додаток від' : 'Новий додаток' }}
                                        {{ item.date | date: 'dd.MM.yyyy' }}
                                    </div>

                                    <button (click)="deleteContractData(i)"
                                            [disabled]="!selectedContractData.data.editable || contractData.length < 2"
                                            class="delete-form-control-button"
                                    >
                                        <mat-icon>delete_outline</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form [formGroup]="contractDataForm" autocomplete="off" class="dialog-form no-top-margin no-overflow scroll-content-padding"
                          style="flex: 1 0 400px; min-width: 400px">
                        <div class="no-overflow full-height df-c gap20">
                            <div class="df gap20">
                                <ng-container *ngIf="data.contract?.id">
                                    <button (click)="nonManagersToggle()"
                                            *ngIf="selectedContractData.data?.managerIgnore || checkPermissions('FINANCIAL_MONITORING')"
                                            class="button-form-field"
                                            [ngClass]="selectedContractData.data?.managerIgnore ? 'warning' : 'gray'"
                                            [matTooltip]="selectedContractData.data?.managerIgnore ? 'Виключено з винагороди менеджера' : 'Виключити з винагороди менеджера?'"
                                            matTooltipClass="tooltip"
                                    >
                                        <mat-icon>person_remove</mat-icon>
                                    </button>
                                </ng-container>
                                <range-date-picker valueType="month" (ngModelChange)="updateSelectedContractData(true)"
                                                       [appearance]="'outline'"
                                                       [disabled]="!selectedContractData.data.editable"
                                                       [label]="'Початок дії'"
                                                       [minDate]="contractForm.get('contractDate')?.value"
                                                       formControlName="date" style="width: 170px; min-width: 170px; max-width: 170px">
                                </range-date-picker>
                                <mat-form-field appearance="outline" class="no-padding full-width grow" floatLabel="always">
                                    <mat-label>Коментар</mat-label>
                                    <input (ngModelChange)="updateSelectedContractData()" formControlName="comment" matInput type="text">
                                </mat-form-field>
                            </div>

                            <div class="df jc-sb ai-c gap15">
                                <b class="dialog-subtitle-label">Склад додатку</b>
                                <mat-checkbox (ngModelChange)="updateSelectedContractData()" *ngIf="getFormArrayControlsQuantity() > 1 && !(['ACCOUNTING', 'BUSINESS_ACCOUNTING'].includes(contractForm.get('type')?.value))"
                                              [disabled]="!selectedContractData.data.editable"
                                              formControlName="singleService">
                                    {{ 'modules.billing.agreements.agreementDialog.labels.invoiceSingleService' | translate }}
                                </mat-checkbox>
                                <mat-divider class="grow"></mat-divider>
                                @if ((contractForm.get('payerType')?.value == 'COUNTERPARTY' || contractForm.get('type')?.value == 'ACCOUNTING') && selectedContractData.data.editable) {
                                    <span (click)="addFormArrayItem()"
                                          class="add-row">{{ 'common.addItem' | translate }}</span>
                                }
                            </div>
                            <div #scrollableContent class="scrollable">
                                <div *ngFor="let contractDataFormControls of getControls(); let i = index"
                                     class="form-array-controls-container"
                                     formArrayName="contractDataFormControls">
                                    <div [formGroupName]="i" class="df gap20">
                                        <div *ngIf="contractForm.get('payerType')?.value == 'COUNTERPARTY'" style="padding-top: 13px">{{ i + 1 }}</div>
                                        <autocomplete-item-field (selected)="confirmGetCalculation($event?.id, i, true)"
                                                                 *ngIf="contractForm.get('payerType')?.value == 'COUNTERPARTY' && contractForm.get('type')?.value !== 'BUSINESS_SAAS' && contractForm.get('type')?.value !== 'BUSINESS_ACCOUNTING'"
                                                                 [canOpenItem]="true"
                                                                 [canOpenList]="true"
                                                                 [dataType]="'ASSOCIATION'"
                                                                 [disabled]="!selectedContractData.data.editable"
                                                                 [lazyLoadModule]="true"
                                                                 [props]="{disableAddContract: true}"
                                                                 formControlName="organization"
                                                                 class="grow"
                                                                 label="{{'modules.billing.agreements.ownerTypes.ASSOCIATION' | translate}}"
                                        ></autocomplete-item-field>

                                        @if (contractForm.get('type')?.value == 'ACCOUNTING' || contractForm.get('type')?.value == 'BUSINESS_ACCOUNTING') {
                                            <mat-form-field appearance="outline" class="no-padding full-width grow" floatLabel="always">
                                                <mat-label>{{ 'Назва' | translate }}</mat-label>

                                                <input
                                                        matInput
                                                        formControlName="name"
                                                        [matAutocomplete]="nameAuto"
                                                        (focus)="onNameInput(i)"
                                                        (input)="onNameInput(i)"
                                                        (blur)="onNameBlur(i)"
                                                >

                                                <mat-autocomplete #nameAuto="matAutocomplete">
                                                    <mat-option
                                                            *ngFor="let option of filteredNames[i] || []"
                                                            [value]="option"
                                                            (onSelectionChange)="onNameSelected(option, i, $event.isUserInput)"
                                                    >
                                                        {{ option }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        }

                                        <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always"
                                                        style="width: 100px; min-width: 100px; max-width: 100px">
                                            <mat-label>{{ 'modules.billing.agreements.agreementDialog.labels.quantity' | translate }}</mat-label>
                                            <input (ngModelChange)="countAmount(i); getTotal(); updateSelectedContractData()" formControlName="qty" matInput
                                                   step=".01" type="number">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always"
                                                        [style.display]="contractForm.get('type')?.value == 'ACCOUNTING' || contractForm.get('type')?.value == 'BUSINESS_ACCOUNTING' ? 'none' : null"
                                                        style="width: 90px"

                                        >
                                            <mat-label>{{ 'Од. вим.' }}</mat-label>
                                            <mat-select (ngModelChange)="updateSelectedContractData()" [disableOptionCentering]="true" class="select-panel" formControlName="unit"
                                                        panelClass="dialog-select-panel">
                                                <mat-option *ngIf="contractForm.get('type')?.value != 'PERSONAL_ACCOUNTING'"
                                                            [value]="'PER_SQUARE_METER'">{{ 'modules.billing.agreements.quantityTypes.PER_SQUARE_METER' | translate }}
                                                </mat-option>
                                                <mat-option [value]="'PER_PAN'">{{ 'modules.billing.agreements.quantityTypes.PER_PAN' | translate }}</mat-option>
                                                <mat-option *ngIf="contractForm.get('type')?.value != 'PERSONAL_ACCOUNTING'"
                                                            [value]="'PER_MONTH'">{{ 'modules.billing.agreements.quantityTypes.PER_MONTH' | translate }}
                                                </mat-option>

                                                @if (contractForm.get('type')?.value == 'ACCOUNTING' || contractForm.get('type')?.value == 'BUSINESS_ACCOUNTING') {
                                                    <mat-option [value]="'PER_ACCRUAL_FLOW_ITEM'">
                                                        {{ 'modules.billing.agreements.quantityTypes.PER_ACCRUAL_FLOW_ITEM' | translate }}
                                                    </mat-option>
                                                    <mat-option [value]="'PER_ACCRUAL_RESOURCE_FLOW_ITEM'">
                                                        {{ 'modules.billing.agreements.quantityTypes.PER_ACCRUAL_RESOURCE_FLOW_ITEM' | translate }}
                                                    </mat-option>
                                                    <mat-option [value]="'PER_EMPLOYEE'">
                                                        {{ 'modules.billing.agreements.quantityTypes.PER_EMPLOYEE' | translate }}
                                                    </mat-option>
                                                    <mat-option [value]="'SERVICE'">
                                                        {{ 'modules.billing.agreements.quantityTypes.SERVICE' | translate }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always"
                                                        style="width: 120px; min-width: 120px; max-width: 120px">
                                            <mat-label>{{ 'modules.billing.agreements.agreementDialog.labels.price' | translate }}</mat-label>
                                            <input (ngModelChange)="countAmount(i); getTotal(); updateSelectedContractData()" formControlName="price" matInput
                                                   step=".01" type="number">
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always"
                                                        style="width: 120px; min-width: 120px; max-width: 120px">
                                            <mat-label>{{ 'modules.billing.agreements.agreementDialog.labels.amount' | translate }}</mat-label>
                                            <input (ngModelChange)="getTotal(); updateSelectedContractData()" formControlName="amount" matInput readonly
                                                   step=".01" type="number">
                                        </mat-form-field>

                                        <div *ngIf="getFormArrayControlsQuantity() > 1 && selectedContractData.data.editable" class="df jc-c ai-c">
                                            <button (click)="deleteFormArrayItem(i)" [disabled]="getControls().length && getControls().length < 2"
                                                    class="delete-form-control-button">
                                                <mat-icon>delete_outline</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </mat-tab>
        <mat-tab [disabled]="!data?.contract?.id" label="{{'Контакти'}}">
            <div class="table-container">
                <ng-container *ngIf="addContactVisible">
                    <form [formGroup]="addContactForm" autocomplete="off" class="scroll-content-padding df jc-s ai-c gap30"
                          style="margin-top: 30px">
                        <div class="df grow gap10">
                            <autocomplete-item-field [canAddItem]="checkPermissions('CONTACT_ADD')"
                                                     [canDeleteItem]="checkPermissions('CONTACT_EDIT')"
                                                     [canEditItem]="checkPermissions('CONTACT_EDIT')"
                                                     [canOpenItem]="true"
                                                     [canOpenList]="true"
                                                     [dataType]="'CONTACT'"
                                                     [lazyLoadModule]="true"
                                                     [multiline]="true"
                                                     [required]="true"
                                                     formControlName="contact"
                                                     style="width: 350px; min-width: 350px; max-width: 350px"
                                                     label="{{'modules.crm.projects.projectDialog.labels.contact' | translate}}"
                            >
                            </autocomplete-item-field>

                            <mat-form-field appearance="outline" class="no-padding grow" floatLabel="always">
                                <mat-label>{{ 'Коментар (посада тощо)' }}</mat-label>
                                <input formControlName="position" matInput type="text">
                            </mat-form-field>

                            <div class="df-c">
                                <div class="df jc-s ai-c">
                                    <mat-checkbox formControlName="email">{{ 'Оповіщення по Email' }}</mat-checkbox>
                                </div>

                                <div class="df jc-s ai-c">
                                    <mat-checkbox formControlName="sms">{{ 'Оповіщення по SMS' }}</mat-checkbox>
                                </div>
                            </div>
                        </div>
                        <span (click)="saveContact()" class="add-row">
                            {{ 'common.save' | translate }}
                        </span>
                    </form>
                </ng-container>

                <mat-table [dataSource]="contactsDataSource" class="dialog-table">
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef class="grow">{{ 'Контакт' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="grow">
                            <app-user-item
                                    (click)="openItem(element.contact.id, 'CONTACT')"
                                    [canCall]="true"
                                    [userName]="element && element.contact && element.contact.name ? element.contact.name : ''"
                                    class="clickable"
                            ></app-user-item>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="comment">
                        <mat-header-cell *matHeaderCellDef class="grow">{{ 'Коментар' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="grow">
                            {{ element.position ? element.position : '-' }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="notifyTypes">
                        <mat-header-cell *matHeaderCellDef style="width: 180px; min-width: 180px; max-width: 180px">{{ 'Оповіщення' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 180px; min-width: 180px; max-width: 180px">
                            <div *ngIf="element?.email || element?.sms" class="df gap20">
                                <mat-icon *ngIf="element?.email"
                                          class="default-icon secondary-icon"
                                          matTooltip="Оповіщення по Email"
                                          matTooltipClass="tooltip">mail
                                </mat-icon>
                                <mat-icon *ngIf="element?.sms"
                                          class="default-icon primary-icon"
                                          matTooltip="Оповіщення по SMS"
                                          matTooltipClass="tooltip">phone_iphone
                                </mat-icon>
                            </div>
                            <div *ngIf="!element?.email && !element?.sms">
                                Не оповіщується
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 80px; min-width: 80px; max-width: 80px">{{ 'common.tableActionsColumn' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let element; let i = index" style="width: 80px; min-width: 80px; max-width: 80px" class="df gap5">
                            <button (click)="editContact(element)" *ngIf="checkPermissions('BILLING_NEW_EDIT')"
                                    class="item-action-button gray">
                                <mat-icon>edit_note</mat-icon>
                            </button>
                            <button (click)="deleteContact(i)" *ngIf="checkPermissions('BILLING_NEW_EDIT')"
                                    class="item-action-button gray">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="contactsColumns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: contactsColumns" class="list-table-row"></mat-row>
                </mat-table>
            </div>
        </mat-tab>
        <mat-tab [disabled]="!data?.contract?.id" label="{{'Файли договору'}}">
            <div class="table-container">
                <mat-table [dataSource]="filesDataSource" class="dialog-table">

                    <ng-container matColumnDef="created">
                        <mat-header-cell *matHeaderCellDef style="width: 200px; min-width: 200px; max-width: 200px">{{ 'Дата формування' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 200px; min-width: 200px; max-width: 200px">
                            {{ element.created | date: 'dd.MM.yyyy HH:mm' }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef class="grow">{{ 'Договір' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="grow">
                            <div class="df-c" style="gap: 2px;">
                                <span>{{ element.name }}</span>
                                <span *ngIf="element.type == 'CONTRACT_WITH_ANNEX' && data.contract?.type == 'SAAS'">
                                    Розрахунок по додатку від {{ element.date | date: 'dd.MM.yyyy' }}
                                </span>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="sign">
                        <mat-header-cell *matHeaderCellDef style="width: 330px; min-width: 330px; max-width: 330px">{{ 'Підписи' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 330px; min-width: 330px; max-width: 330px">
                            <div class="df gap5">
                                <div *ngIf="element.signedOffline">{{ 'Підписано власноруч' }}</div>
                                <div *ngIf="!element.signedOffline" class="df jc-s ai-c gap20">
                                    <div class="file-sign">
                                        <span class="bold">Дах КЕП:</span>
                                        <div *ngIf="element.signersDah?.length" class="signed">
                                            {{ 'Підписано' }}
                                        </div>
                                        <button (click)="signContractFile(element)"
                                                *ngIf="!element.signersDah?.length && checkPermissions('BILLING_NEW_SIGN_EDIT')"
                                                class="action-button blue"
                                        >
                                            {{ 'Підписати' }}
                                        </button>
                                    </div>
                                    <div class="file-sign">
                                        <span class="bold">Клієнт КЕП:</span>
                                        <span [ngClass]="element.signersClient?.length ? 'signed' : 'not-signed'">
                                            {{ element.signersClient?.length ? 'Підписано' : 'Не підписано' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 120px; min-width: 120px; max-width: 120px">{{ 'common.tableActionsColumn' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 120px; min-width: 120px; max-width: 120px" class="df gap5">
                            <button (click)="downloadContractFile(element, true)"
                                    *ngIf="!element.signersDah && !element.signersClient"
                                    class="item-action-button gray">
                                <mat-icon>file_download</mat-icon>
                            </button>

                            <button *ngIf="!element.signedOffline && (element.signersDah || element.signersClient)"
                                    [matMenuTriggerFor]="downloadContractFileMenu"
                                    class="item-action-button gray">
                                <mat-icon>file_download</mat-icon>
                            </button>
                            <mat-menu #downloadContractFileMenu xPosition="before">
                                <button (click)="downloadContractFile(element, true)" class="item-action-button gray" mat-menu-item>
                                    <mat-icon>file_download</mat-icon>
                                    <span>{{ 'Скачати без підпису' }}</span>
                                </button>
                                <button (click)="downloadContractFile(element, false)" class="item-action-button gray" mat-menu-item>
                                    <mat-icon>draw</mat-icon>
                                    <span>{{ 'Скачати з КЕП' }}</span>
                                </button>
                            </mat-menu>
                            <button (click)="toggleContractFileSignedState(element)"
                                    *ngIf="checkPermissions('BILLING_NEW_TRANSACTION_EDIT') && !element.signersClient?.length"
                                    class="item-action-button gray"
                                    matTooltip="{{element.signedOffline ? 'Зняти помітку про підпис' : 'Помітити як підписаний вручну'}}"
                                    matTooltipClass="tooltip"
                            >
                                <mat-icon>draw</mat-icon>
                            </button>
                            <button (click)="deleteContractFile(element)" *ngIf="checkPermissions('BILLING_NEW_EDIT') || checkPermissions('BILLING_SINGLE_CONTRACT_EDIT')"
                                    class="item-action-button gray">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="filesColumns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: filesColumns" class="list-table-row"></mat-row>
                </mat-table>
            </div>
        </mat-tab>
        <mat-tab [disabled]="!data?.contract?.id || !checkPermissions('BILLING_NEW_ACT_READ')" label="{{'Документи'}}">
            <div class="table-container">
                <mat-table [dataSource]="documentsDataSource" class="dialog-table">

                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef class="grow">{{ 'Документ' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="grow">
                            <div class="df-c gap5">
                                <div class="df ai-c gap10">
                                    <span class="doc-badge {{element.type}}">{{ documentTypeName(element) }}</span>
                                    <span [class.reversed]="element.reversed">{{ element.name }}</span>
                                    <span class="doc-badge reversed" *ngIf="element.reversed">Сторновано</span>
                                    <span class="doc-badge tax" *ngIf="element.taxInvoiceRegistered">ПН зареєстровано</span>
                                </div>
                                <span *ngIf="element.period" class="period">{{ element.period }}</span>
                                <span *ngIf="element.comment" class="error">{{ element.comment }}</span>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef style="width: 200px; min-width: 200px; max-width: 200px">{{ 'Сума' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 200px; min-width: 200px; max-width: 200px">
                            <div class="df-c gap10">
                                <span>{{ element.amount | currency:'UAH':'грн.':'0.2-2' }}</span>
                                <span *ngIf="element.uncovered > 0"
                                      class="error"
                                      matTooltip="Незакрито платежем"
                                      matTooltipClass="tooltip"
                                >
                                    {{ element.uncovered | currency:'UAH':'грн.':'0.2-2' }}
                                </span>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="state">
                        <mat-header-cell *matHeaderCellDef style="width: 280px; min-width: 280px; max-width: 280px">{{ 'Стан' }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 280px; min-width: 280px; max-width: 280px">
                            <div class="df gap5" *ngIf="isAct(element)">
                                <div *ngIf="element.signType == 'MANUALLY_SIGNED'">{{ 'Підписано власноруч' }}</div>
                                <div *ngIf="element.signType != 'MANUALLY_SIGNED'" class="df jc-s ai-c gap20">
                                    <div class="file-sign">
                                        <span class="bold">Дах КЕП:</span>
                                        <span [ngClass]="element.signersDah?.length ? 'signed' : 'not-signed'">
                                            {{ element.signersDah?.length ? 'Підписано' : 'Не підписано' }}
                                        </span>
                                    </div>
                                    <div class="file-sign">
                                        <span class="bold">Клієнт КЕП:</span>
                                        <span [ngClass]="element.signersClient?.length ? 'signed' : 'not-signed'">
                                            {{ element.signersClient?.length ? 'Підписано' : 'Не підписано' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="element.type == 'INVOICE'">
                                <span *ngIf="element.sentAt">Відправлено {{ element.sentAt | date: 'dd.MM.yyyy HH:mm' }}</span>
                                <span class="not-signed" *ngIf="!element.sentAt">Не відправлено</span>
                            </div>
                            <div *ngIf="isTransaction(element) || element.type == 'ADJUSTMENT'">
                                {{ element.date | date: 'dd.MM.yyyy HH:mm' }}
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef style="width: 200px; min-width: 200px; max-width: 200px">{{ 'common.tableActionsColumn' | translate }}</mat-header-cell>
                        <mat-cell *matCellDef="let element" style="width: 200px; min-width: 200px; max-width: 200px" class="df gap5">

                            <button [matMenuTriggerFor]="documentFileMenu"
                                    *ngIf="element.link || isAct(element)"
                                    class="item-action-button gray">
                                <mat-icon>file_download</mat-icon>
                            </button>
                            <mat-menu #documentFileMenu xPosition="before">
                                <button (click)="openLink(element)" class="item-action-button gray" mat-menu-item [disabled]="!element.link">
                                    <mat-icon>link</mat-icon>
                                    <span>{{ 'Переглянути файл' }}</span>
                                </button>
                                <button (click)="downloadActFile(element, true)" class="item-action-button gray" mat-menu-item *ngIf="isAct(element)">
                                    <mat-icon>file_download</mat-icon>
                                    <span>{{ 'Скачати файл акту' }}</span>
                                </button>
                                <button (click)="downloadActFile(element, false)"
                                        *ngIf="isAct(element) && (element.signersDah?.length || element.signersClient?.length)"
                                        class="item-action-button gray"
                                        mat-menu-item>
                                    <mat-icon>draw</mat-icon>
                                    <span>{{ 'Скачати файл акту з КЕП' }}</span>
                                </button>
                            </mat-menu>

                            <button (click)="signAct(element)"
                                    *ngIf="isAct(element) && checkPermissions('BILLING_NEW_SIGN_EDIT') && !element.reversed && !element.signersDah?.length && element.signType != 'MANUALLY_SIGNED'"
                                    class="item-action-button gray"
                                    matTooltip="Підписати КЕП з боку Дах"
                                    matTooltipClass="tooltip"
                            >
                                <mat-icon>verified</mat-icon>
                            </button>
                            <button (click)="toggleActSignedState(element)"
                                    *ngIf="isAct(element) && checkPermissions('BILLING_NEW_TRANSACTION_EDIT') && !element.reversed && !element.signersClient?.length"
                                    class="item-action-button gray"
                                    matTooltip="{{element.signType == 'MANUALLY_SIGNED' ? 'Зняти помітку про підпис' : 'Помітити як підписаний вручну'}}"
                                    matTooltipClass="tooltip"
                            >
                                <mat-icon>draw</mat-icon>
                            </button>
                            <button (click)="openDocument(element)"
                                    *ngIf="element.type != 'ADJUSTMENT' && canEditDocument(element)"
                                    class="item-action-button gray">
                                <mat-icon>edit_note</mat-icon>
                            </button>
                            <button (click)="deleteDocument(element)"
                                    *ngIf="(element.type == 'INVOICE' || isAct(element)) && !element.reversed && checkPermissions('BILLING_NEW_ACT_EDIT')"
                                    class="item-action-button gray"
                                    matTooltip="{{element.taxInvoiceRegistered ? 'Сторнувати' : 'Видалити'}}"
                                    matTooltipClass="tooltip">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="documentsColumns; sticky: true" class="list-table-header"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: documentsColumns" class="list-table-row"></mat-row>
                </mat-table>
            </div>

            <mat-paginator
                    [length]="documentsPagination.totalElements"
                    [pageIndex]="documentsPagination.number"
                    [pageSize]="documentsPagination.size"
                    [pageSizeOptions]="config.paginationConfig.pageSizeOptions"
                    (page)="changeDocumentsPage($event)"
            ></mat-paginator>

            <div *ngIf="showDeletedActs" class="df-c gap10" style="margin: 20px 30px 20px 0; padding: 10px 0; border-top: 1px dashed darkred">
                <div *ngFor="let act of deletedActs" class="df gap20">
                    <span>{{ act.name }}</span>
                    <span>Видалено: {{ act.deletedBy?.name }}</span>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
<div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="buttons-row df jc-sb ai-c gap20">
    <div class="total-info-container df gap30">
        <div class="total-info-item">
            <span>{{ 'Сума по обраному додатку' }}:</span>
            <span>
                {{ totalAmount | currency:'UAH': 'грн.':'0.2-2' }}
            </span>
        </div>
        <div *ngIf="data.contract && data.contract.amounts && data.contract.amounts.balance"
             [ngClass]="data && data.contract && data.contract.amounts && data.contract.amounts.balance && data.contract.amounts.balance > 0 ? 'success' : 'warning'"
             class="total-info-item">
            <span>{{ 'modules.billing.agreements.agreementDialog.labels.currentBalance' | translate }}:</span>
            <span>
                {{ data.contract!.amounts!.balance | currency:'UAH': 'грн.':'0.2-2' }}
            </span>
        </div>
        <div *ngIf="documentsPagination.totalElements" class="total-info-item">
            <span>{{ 'Документів' }}:</span>
            <span>{{ documentsPagination.totalElements }}</span>
        </div>
        <div (click)="showDeletedActs = !showDeletedActs" *ngIf="deletedActs?.length" class="total-info-item clickable">
            <span>{{ 'Видалені акти' }}:</span>
            <span>{{ deletedActs?.length }}</span>
        </div>
    </div>
    <div *ngIf="checkPermissions('BILLING_NEW_EDIT') || checkPermissions('BILLING_SINGLE_CONTRACT_EDIT')" class="df jc-e ai-c gap20">
        <button (click)="submitForm(false)" [disabled]="(contractDataForm.invalid || contractForm.invalid) && (loading$ | async) === false"
                class="default-button apply-button-flat">
            {{ 'common.save' | translate }}
        </button>
        <button (click)="submitForm(true)" [disabled]="(contractDataForm.invalid || contractForm.invalid) && (loading$ | async) === false" class="default-button apply-button">
            {{ 'common.saveAndClose' | translate }}
        </button>
    </div>
</div>
